import routes from '@/router-session'
import {mapState} from 'vuex'

let routerComponents = {}
let routerComponentsData = {}

routes.forEach(route => {
    addComponent(route)
    if (route.children) {
        route.children.forEach(childRoute => addComponent(childRoute))
    }
})

function addComponent (route) {
    routerComponentsData[route.key] = route

    if (route.component) {
        routerComponents[route.key] = route.component
    } else if (route.components) {
        routerComponents[route.key] = route.components.default
        if (route.components.aside) {
            routerComponentsData[route.key].aside = true
            routerComponents[route.key + '-aside'] = route.components.aside
        }
    }
}

export default {
    components: {
        ...routerComponents
    },
    computed: {
        ...mapState('session', ['route']),
        activeRoute () {
            let route = routerComponentsData[this.route]
            if (route) {
                return {
                    default: route.key,
                    aside: route.aside && route.key + '-aside',
                    options: route.options || {}
                }
            } else {
                return null
            }
        }
    }
}
